import React, { useEffect, useState } from "react";
import "./postpage.css";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { useParams } from 'react-router-dom';
import blogsData from "../blogs";
import { Typography } from "@mui/material";

function PostsPage() {
  const { id } = useParams();

  const [width, setWidth] = useState(window.innerWidth);
  const [blog, setBlog] = useState({}); 

  useEffect( ()=> {
    setBlog(blogsData.find(post => post.id === parseInt(id)));
    console.log(blogsData.find(post => post.id === parseInt(id)));
  }, []);

  useEffect(() => {
    // Function to update the width
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener

    // hover code :
    // group-hover:shadow-2xl group-hover:scale-105
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>{
      blog?.id
      ?
      <div className="postsPage text-white">
        <Typography variant="h6" sx={{ fontFamily: "Crimson Text, serif" }}>{blog?.title}</Typography>
        <div className="homePosts flex justify-start my-2">
          <div
            className={`homeAuthorTitle w-full flex ${
              width < 850
                ? "flex-col items-start justify-start"
                : "flex-row items-center justify-between"
            }  `}
          >
            <div className="gap-5 my-2 flex flex-row flex-wrap">
              {blog?.tags?.map((value, index) => (
                <span key={index}>
                  <button className="w-fit px-2 p-1 text-white rounded-t-full rounded-br-full bg-gray-500">
                    {value}
                  </button>
                </span>
              ))}
            </div>

            <div className={`pt-[5px] text-[#6b6b6b] flex`}>
              <p className="font-sans text-base my-2">{blog?.readTime} - </p>
              <p className="font-sans text-base my-2">{blog?.publishedAt}</p>
            </div>
          </div>
        </div>

        <hr />

        <div className="w-full my-1 mt-[30px] mx-1 flex justify-center">
          <img
            className={`${width < 850 ? "w-full" : "w-[70%]"}`}
            src={blog?.featuredImage}
            alt="image"
          />
        </div>

        {/* <div className="btnsMainDiv py-[15px] px-[10px]">
            <div className="btnsLeftDiv gap-5">
              <div className="btnsDiv">
                <div>
                  <span>
                    <FavoriteBorderIcon sx={{ color: "red" }} />
                  </span>
                </div>
                <div className="pl-[5px]">
                  <span>{blog.likes_count}</span>
                </div>
              </div>
            </div>
          </div> */}
        <div className="blog-content">
          {blog?.content?.map((block, index) => {
            switch (block?.type) {
              case "text":
                return (
                  <p key={index} className="font-sans text-base my-2">
                    {block?.text}
                  </p>
                );
              case "image":
                return (
                  <div
                    key={index}
                    className="w-full my-1 mt-[30px] mx-1 flex justify-center"
                  >
                    <img
                      className={`${width < 850 ? "w-full" : "w-[70%]"}`}
                      src={block?.image}
                      alt="image"
                    />
                  </div>
                );
              default:
                return null;
            }
          })}
        </div>

        <div className="postEnd py-[50px]">
          <span className="dot"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
      </div>
      :
      <p className="text-white"> Sorry this blog is currently not available</p>
    }
      
    </>
  );
}

export default PostsPage;
